"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputTextArea = void 0;
var estiloInputTextArea = require("./InputTextArea.module.scss");
var react_1 = __importStar(require("react"));
var HelperText_1 = require("../../HelperText/HelperText");
var Label_1 = require("../../Label/Label");
var Cores_1 = require("../../Cores/Cores");
var InputTextArea = function (_a) {
    var _b;
    var _c = _a.id, id = _c === void 0 ? "" : _c, _d = _a.placeholder, placeholder = _d === void 0 ? "" : _d, valor = _a.valor, _e = _a.label, label = _e === void 0 ? true : _e, _f = _a.quantidadeLinhaInicial, quantidadeLinhaInicial = _f === void 0 ? 10 : _f, _g = _a.quantidadeLinhaMaxima, quantidadeLinhaMaxima = _g === void 0 ? 15 : _g, _h = _a.textoLabel, textoLabel = _h === void 0 ? "Texto:" : _h, _j = _a.variante, variante = _j === void 0 ? "regular" : _j, _k = _a.desabilitado, desabilitado = _k === void 0 ? false : _k, _l = _a.readonly, readonly = _l === void 0 ? false : _l, _m = _a.autofocus, autofocus = _m === void 0 ? false : _m, conteudoDeAjuda = _a.conteudoDeAjuda, _o = _a.maxLength, maxLength = _o === void 0 ? 200 : _o, onChange = _a.onChange, onError = _a.onError, onBlur = _a.onBlur, onFocus = _a.onFocus;
    var estiloVariacao = estiloInputTextArea[variante];
    var disabledStyle = estiloInputTextArea.disabled || "";
    var inputfieldStyle = desabilitado ? disabledStyle : estiloVariacao;
    var _p = (0, react_1.useState)(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600), cor = _p[0], setCor = _p[1];
    var _q = (0, react_1.useState)(valor !== null && valor !== void 0 ? valor : ""), inputValue = _q[0], setInputValue = _q[1];
    var _r = (0, react_1.useState)(valor ? valor.length : (_b = inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) !== null && _b !== void 0 ? _b : 0), charCount = _r[0], setCharCount = _r[1];
    var inputRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var novoValor = valor !== null && valor !== undefined ? valor.toString() : "";
        setInputValue(novoValor);
        setCharCount(novoValor.length);
        // Deferido para garantir que scrollHeight reflita o conteúdo corretamente
        setTimeout(function () {
            if (inputRef.current) {
                inputRef.current.style.height = "auto";
                var novaAltura = Math.min(inputRef.current.scrollHeight, quantidadeLinhaMaxima * 20);
                inputRef.current.style.height = "".concat(novaAltura, "px");
                inputRef.current.style.overflowY = novaAltura >= quantidadeLinhaMaxima * 20 ? "scroll" : "hidden";
            }
        }, 0);
    }, [valor]);
    (0, react_1.useEffect)(function () {
        desabilitado && setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU400);
        if (!desabilitado) {
            switch (variante) {
                case "success":
                    setCor(Cores_1.Cores.MensagensDoSistema.VerdeMU);
                    break;
                case "error":
                    setCor(Cores_1.Cores.MensagensDoSistema.VermelhoMU);
                    break;
                case "regular":
                    setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600);
                    break;
            }
        }
    }, [variante, desabilitado]);
    var handleChange = function (event) {
        var valorAtual = event.target.value;
        setInputValue(valorAtual);
        setCharCount(valorAtual.length);
        onChange && onChange(valorAtual);
        if (inputRef.current) {
            inputRef.current.style.height = "auto";
            var newHeight = Math.min(inputRef.current.scrollHeight, quantidadeLinhaMaxima * 20);
            inputRef.current.style.height = "".concat(newHeight, "px");
            inputRef.current.style.overflowY = newHeight >= quantidadeLinhaMaxima * 20 ? "scroll" : "hidden";
        }
    };
    var handleBlur = function (event) {
        onBlur && onBlur(event);
    };
    var handleFocus = function (event) {
        onFocus && onFocus(event);
    };
    var ConteudoAjuda = (react_1.default.createElement(HelperText_1.HelperText, { texto: (conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.texto) || '', desabilitado: desabilitado, estado: estiloVariacao, icone: conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.icone }));
    var style = textoLabel || conteudoDeAjuda ? { gap: '8px' } : {};
    return (react_1.default.createElement("div", { className: estiloInputTextArea.container, style: style },
        react_1.default.createElement("div", { className: estiloInputTextArea.conteudo },
            label && react_1.default.createElement(Label_1.Label, { texto: textoLabel }),
            react_1.default.createElement("div", { className: "".concat(estiloInputTextArea.textarea, "  ").concat(inputfieldStyle) },
                react_1.default.createElement("textarea", { id: id, ref: inputRef, readOnly: readonly, autoFocus: autofocus, value: inputValue !== null ? inputValue : "", disabled: desabilitado, placeholder: placeholder, maxLength: maxLength, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, style: {
                        minHeight: "".concat(quantidadeLinhaInicial * 20, "px"),
                        maxHeight: "".concat(quantidadeLinhaMaxima * 20, "px"),
                        overflowY: "hidden",
                        resize: "none",
                    } })),
            conteudoDeAjuda && ConteudoAjuda,
            react_1.default.createElement("div", { className: "".concat(estiloInputTextArea.charCount), style: { textAlign: 'right', marginTop: '8px' } },
                charCount,
                "/",
                maxLength,
                " caracteres"))));
};
exports.InputTextArea = InputTextArea;
